var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7706 25.0857L18.1707 3.8855L10.5708 25.0857H25.7706ZM27.4293 29.6565H8.915L5.19956 40H0L14.4 0H21.9422L36.3433 40H31.1427L27.4293 29.6565Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8871 19.1997C61.7731 19.1997 64.629 16.3428 64.629 11.7142C64.629 7.14231 61.7731 4.62859 55.8871 4.62859H46.3434V19.1997H55.8871ZM70.2295 40H64.5734C62.6296 37.6574 62.3441 34.2284 62.3441 31.8858C62.3441 28.628 62.9151 26.1142 60.1726 23.7716H46.3435V40H41.2584V0H55.8872C64.2302 0 69.8296 4.1143 69.8296 11.7709C69.8296 17.7135 66.6862 20.8003 62.173 21.6567C67.3726 23.1996 67.487 27.7148 67.5437 31.5426C67.6014 34.4572 68.2291 37.7141 70.2295 40Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.465 28.2656C103.044 32.3335 104.96 36.6276 107.216 39.7346H101.634C99.6596 37.1361 97.9124 32.1633 96.5028 28.661L92.1602 17.6996L82.2923 27.8692V39.7346H77.2744V0.185913H82.2923V20.8636L102.367 0.185913H109.133L95.8825 13.8579L101.465 28.2656Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.748 4.7052V17.135H139.863V21.6553H118.748V35.2142H142.09V39.7346H113.527V0.185913H142.09V4.7052H118.748Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.442 4.7052H164.995V39.7346H159.831V4.7052H145.386V0.185913H179.442V4.7052Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArket);
export default __webpack_public_path__ + "static/media/Arket.0d470a5c40b344a1cedde5595798ad5d.svg";
export { ForwardRef as ReactComponent };